import {useMemo, useRef} from 'react'

import Icon from '../../../icons/Icon.js'
import Popover from './Popover.js'
import Zropdown, {RootLessZropdownList} from '../../Zropdown.js'
import {
  formSelector,
  getState,
  updateForm,
  useAutoForm,
} from '../../../../store.js'
import {setCurrentDropdown} from '../../../../redux/actions/ui/currentDropdown.js'
import {currentDropdownSelector} from '../../../../redux/selectors/ui/index.js'

let id = 0

function closeHoverDropdown(formName) {
  const form = formSelector(getState(), {formName})
  const currentDropdown = currentDropdownSelector(getState())

  if (!form || currentDropdown !== formName) {
    return
  }

  setCurrentDropdown(null)
}

function onHoverEvent(formName, isHover) {
  const form = formSelector(getState(), {formName})

  if (isHover) {
    if (form.closeTimeout) {
      clearTimeout(form.closeTimeout)
    }

    updateForm(formName, {closeTimeout: null})
    setCurrentDropdown(formName)
  } else {
    if (form.closeTimeout) {
      clearTimeout(form.closeTimeout)
    }

    updateForm(formName, {
      closeTimeout: setTimeout(() => closeHoverDropdown(formName), 250),
    })
  }
}

/**
 * A icon to allow the popover of comments to pop from
 *
 * @param {Object} props
 * @param {String} props.type
 * @param {String} props.title
 * @param {Function} props.commentGroupsSelector
 * @param {Function} props.ensureComments
 * @returns {React.ReactNode}
 */
export default function TimelinePopover({
  type,
  title,
  commentGroupsSelector,
  ensureComments,
}) {
  const iconRef = useRef()
  const dropdown = useMemo(() => `timeline_popover_${id++}`, [])

  useAutoForm(dropdown, {})

  return (
    <div
      className={`wrap--${type}-timeline-pop-over`}
      onMouseEnter={() => onHoverEvent(dropdown, true)}
      onMouseLeave={() => onHoverEvent(dropdown, false)}
      data-dropdown={dropdown}
    >
      <div className="wrap--pop-over padding-right-5 inline-block">
        <div ref={iconRef} key="icon">
          <Icon name="clock-o" className="icon--pop-over op-30 fs-00" />
        </div>
        <Zropdown
          className="wrap--pop-over-timeline"
          dropdown={dropdown}
          parentRef={iconRef}
          RootOfChildren={RootLessZropdownList}
          onMouseLeave={() => onHoverEvent(dropdown, false)}
          preventClose
        >
          <Popover
            title={title}
            commentGroupsSelector={commentGroupsSelector}
            ensureComments={ensureComments}
          />
        </Zropdown>
      </div>
    </div>
  )
}
